import React from "react";
import "./Services-list.css";
import { services } from "portfolio";
import ServicesCard from "./Service-card";
import { Fade } from "react-reveal";

export default function ServicesContainer(props) {
    const theme = props.theme;
    return (
        <Fade bottom duration={2000} distance="40px">
            <div className="services-container">
                {services.data.length > 0 ? (
                    <div className="repo-cards-div-main">
                        {services.data.map((serv) => (
                            <ServicesCard key={serv.id} serv={serv} theme={theme} />
                        ))}
                    </div>
                ) : (
                    <p className="coming-soon">Bientôt disponible</p>
                )}
            </div>
        </Fade>
    );
}
